import { useEffect, useState } from 'react';

/** Значення із затримкою (пошук під час введення не надсилає запит на кожну літеру). */
export function useDebounced<T>(value: T, ms = 220): T {
  const [current, setCurrent] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setCurrent(value), ms);
    return () => clearTimeout(timer);
  }, [value, ms]);
  return current;
}
